import { render, staticRenderFns } from "./DynamicComponentsFilesDropzone.vue?vue&type=template&id=61b174b8&lang=pug&"
import script from "./DynamicComponentsFilesDropzone.vue?vue&type=script&lang=js&"
export * from "./DynamicComponentsFilesDropzone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports